events.eventsSignalrModule = {
    // Spustenie signalR
    async startSignalR() {
        try {
            if (![signalR.HubConnectionState.Connected,
                signalR.HubConnectionState.Connecting,
                signalR.HubConnectionState.Reconnecting,
                signalR.HubConnectionState.Disconnecting].includes(connection.state)) {
                await connection.start();
                if (connection.state === signalR.HubConnectionState.Connected) {
                    events.eventsSignalrModule.setSignalR();
                } else {
                    // Obnovi dopytovanie zmien kurzov pomocou ticket delta
                    ticket.setTicketRefresh();
                    if (profile.ConsoleLog || profile.ConsoleLog$.SignalR) console.log("SignalrStartPromiseResolvedNotConnected #connection.state: " + connection.state);
                }
            }

        } catch (e) {
            // SignalR nenadviazal spojenie pri prvotnom pripajani
            main.createLog(2, "SignalrStartPromiseCatch", e.message);
            // Nastavi ticket deltu pre polling zmien pre kurzy na rozpracovanom tikete
            ticket.setTicketRefresh();
        }
    },

    // Odhlasenie zo signalR hubu
    async stopSignalR() {
        try {
            if (connection?.state === signalR.HubConnectionState.Connected) {
                // Zastavenie signalR hubu
                await connection.stop();
                if (profile.ConsoleLog || profile.ConsoleLog$.SignalR) console.log("stopSignalR() State after stop #connection.state: " + connection.state);
            } else {
                if (profile.ConsoleLog || profile.ConsoleLog$.SignalR) console.log("stopSignalR() signalR not connected #connection.state: " + connection?.state);
            }
        } catch (e) {
            if (profile.ConsoleLog || profile.ConsoleLog$.SignalR) console.error("stopSignalR() catch: " + e.message + " #connection.state: " + connection?.state);
            return false;
        }
    },

    async changeViewSignalR(previousView) {
        try {
            if (profile.ConsoleLog || profile.ConsoleLog$.SignalR) console.log("### ChangeView: " + offer.signalrView);
            await connection.invoke("ChangeView", offer.signalrView, previousView);
            // Pre zmenu oddov sa uz nespoliehame na signalR - https://codium-fsm.atlassian.net/browse/OF-97
            // Povodne sme vypinali ticket deltu cez:
            // rfs.ticket && ticket.stopTicketRfs();
            if (profile.ConsoleLog || profile.ConsoleLog$.SignalR) console.log("changeViewSignalR #offer.signalrView: " + offer.signalrView + " #previousView:" + previousView);
        } catch (e) {
            // Ak sa nepodarilo zmenit view:
                // The server method throws an exception
                // The method name is incorrect or not found on the server
                // The connection is closed or interrupted before the method completes
                // The server returns a rejected task or throws an error during execution
            // Obnovi dopytovanie zmien kurzov pomocou ticket delta
            ticket.setTicketRefresh();
            if (profile.ConsoleLog || profile.ConsoleLog$.SignalR) console.error("changeViewSignalR catch: " + e + " #connection.state: " + connection?.state);
            return false;
        }
    },

    // Funkcia na resetovanie delty tiketu
    ticketDeltaClear: function(clearPendingCount) {
        clearTimeout(delta.ticketDeltaTimeout);
        delta.ticketDeltaTimeout = null;
        delta.ticketDeltaRequest = null;
        clearPendingCount && (delta.ticketDeltaPendingCount = 0);
    },

    // Nastavenie pohladu na signalR hub
    setSignalR: function(refresh) {
        try {
            if (!refresh) {
                var previousView = [];
                if (offer.signalrView) previousView = offer.signalrView;

                if (!offer.multiView) {
                    if (offer.sportID == -1 && offer.sportEventID == -1) {
                        offer.signalrView = [];
                    } else {

                        if (offer.sportEventID == -1 && offer.favSportID == -1) {

                            // Sport
                            offer.signalrView = "S_" + offer.sportID;
                            // Region
                            if (offer.regionID != -1) {
                                offer.signalrView += "_R_" + offer.regionID;
                                // Liga
                                if (offer.leagueCupID != -1) {
                                    offer.signalrView += "_L_" + offer.leagueCupID;
                                    if (offer.sportID === offer.vgID) {
                                        offer.signalrView += "_VG";
                                    }
                                }
                            }
                        } else {
                            if (offer.sportEventID != -1) {
                                // SportEvent
                                offer.signalrView = "SE_" + offer.sportEventID;
                                // Sport
                                if (offer.sportID != -1) {
                                    offer.signalrView += "_S_" + offer.sportID;
                                    // Liga
                                    if (offer.leagueCupID != -1) offer.signalrView += "_L_" + offer.leagueCupID;
                                }
                            } else {
                                // Favorite
                                if (offer.sportID != -1 && offer.pointer !== "FA0") {
                                    offer.signalrView = "S_" + offer.sportID;
                                    // Liga
                                    if (offer.leagueCupID != -1) offer.signalrView += "_L_" + offer.leagueCupID;
                                }
                            }
                        }
                    }

                    if (offer.signalrView.length || (offer.page === "onlyLive" && offer.sportEventID === -1 && offer.regionID === -1 && offer.leagueCupID === -1) || (offer.pointer === "FA0" && offer.favSportID === true)) {
                        if (offer.onlyLive == 1 || offer.pointer === "FA0") offer.signalrView += "_LIVE";

                        if (!offer.eventID) {
                            offer.signalrView = [offer.signalrView];
                            if (offer.page == "virtualGames") {
                                if (offer.vgL.evona.includes(offer.leagueCupID)) {
                                    var firstDetail = $('#section fieldset:not(.event-suspended):first').find('.ui-block-5 a').attr('id');
                                    offer.signalrView.push("E_" + firstDetail, "Stream");
                                }
                            }
                        } else {
                            offer.signalrView = [offer.signalrView, "E_" + offer.eventID];
                            // Virtualky - Jackpot a Stream
                            if (offer.page == "virtualGames") {
                                offer.signalrView.push("Jackpot");
                                if (offer.vgL.evona.includes(offer.eventLeagueCupID)) {
                                    offer.signalrView.push("Stream");
                                }
                            }
                        }
                    } else if (offer.eventID) {
                        offer.signalrView = ["E_" + offer.eventID];
                    }

                    if (["lastMinute", "today", "otherDates"].includes(offer.page) && offer.sportID === -1 && offer.sportEventID === -1 && offer.regionID === -1 && offer.leagueCupID === -1) {
                        // Nevybrany sport na strankach "lastMinute", "today", "otherDates" nastavi "_LIVE" signalrView 
                        offer.signalrView.push("_LIVE");
                    }
                } else {

                    // MultiView pouzite pri GoldenLeague
                    if (offer.leagueCupID != -1) {
                        $.each(offer.multiView, function (i, id) {
                            if (id.indexOf("L_" + offer.leagueCupID) != -1) {
                                offer.signalrView = [offer.multiView[i]];
                                return false;
                            }
                        });
                    } else {
                        offer.signalrView = offer.multiView;
                    }
                }

                var actualPlayerView = false;
                if (offer.signalrView && offer.signalrView.length) {
                    actualPlayerView = offer.signalrView.find(function(view) {
                        return view.includes('bb_');
                    });
                }

                if (stored.PlayerID && stored.PlayerID !== profile.ManualVerifiedPlayerID) {
                    var futurePlayerView = "bb_" + stored.PlayerID;
                    if (actualPlayerView && (actualPlayerView !== futurePlayerView)) {
                        var playerIndex = offer.signalrView.indexOf(actualPlayerView);
                        if (playerIndex !== -1) {
                            offer.signalrView.splice(playerIndex, 1);
                        }
                    }
                }
                // Nastavi view pre Jackpoty
                if (offer.signalrView.length && offer.jackpotCodes) {
                    offer.signalrView = offer.signalrView.concat(offer.jackpotCodes);
                }
                // Nastavi view pre playera
                if (!actualPlayerView && futurePlayerView) {
                    offer.signalrView.push(futurePlayerView);
                }

                // Prida EVCT do signalR view koli preberaniu zmien oddov v rozrobenom tikete
                offer.signalrView = offer.signalrView
                    .concat(
                        odds?.reduce((acc, { EventChanceTypeID }) => {
                            return EventChanceTypeID ? [...acc, `EVCT_${EventChanceTypeID}`] : acc;
                        }, [])
                    );

                offer.signalrView = offer.signalrView.concat(stream.streamSignalRView || []);

                // Ak je potrebne zmenit SignalR view
                if (offer.signalrView.length || previousView.length) {
                    if (connection.state === signalR.HubConnectionState.Connected) {
                        events.eventsSignalrModule.changeViewSignalR(previousView);
                    } else if (![signalR.HubConnectionState.Connected, signalR.HubConnectionState.Connecting, signalR.HubConnectionState.Reconnecting].includes(connection.state)) {
                        connection.start();
                    }
                }

                return true;
            }

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia ktora priravi multiView pre signalR
    setMultiView: function(data) {
        try {
            if (offer.goldenLeague) {
                offer.multiView = [];
                $.each(data, function (i, id) {
                    if (id.Categorization) {
                        id = id.Categorization.split("_");
                        if (id.length == 3 && data[i].ID) {

                            if (id[0] == -1) {
                                offer.multiView.push("S_" + id[1] + "_R_" + id[2] + "_L_" + data[i].ID);
                            } else {
                                offer.multiView.push("SE_" + id[0] + "_S_" + id[2] + "_L_" + data[i].ID);
                            }
                        } else {
                            return false;
                        }
                    } else {
                        offer.multiView = null;
                        return false;
                    }
                });
            } else {
                offer.multiView = null;
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            offer.multiView = null;
            return false;
        }
    },

    // Inicializacia SignalR
    initSignalR: function() {
        try {
            if (connection && connection.state === signalR.HubConnectionState.Connecting) {
                return true;
            }
            setTimeout(function () {
                var signalRSettings = {};
                // Signalr pri locahost-e pouziva websockets
                if (sets.hostnames.includes(window.location.hostname) || ["LBR", "STAGING"].includes(offer.country)) {
                    // Localhost bez negotiation fazy, Docasny fix pre LBR, STAGING - winform nefunguje sticky session
                    signalRSettings = { 
                        skipNegotiation: true,
                        transport: signalR.HttpTransportType.WebSockets
                    };
                }
                // Inicializacia pripojenia
                connection = new signalR.HubConnectionBuilder()
                    .withUrl(url.signalR, signalRSettings)
                    // Automaticky reconnect (strata spojenia)
                    .withAutomaticReconnect({
                        nextRetryDelayInMilliseconds: () => sets.reconnectHub
                    })
                    .build();

                    connection.onreconnecting(function(error) {
                        if (profile.ConsoleLog || profile.ConsoleLog$.SignalR) console.warn("SignalR is reconnecting... " + error);
                    });

                    connection.onreconnected(function(connectionId) {
                        if (profile.ConsoleLog || profile.ConsoleLog$.SignalR) console.log("SignalR has been reconnected: " + connectionId);
                    });

                    connection.onclose(function(error) {
                        if (profile.ConsoleLog || profile.ConsoleLog$.SignalR) console.log("SignalR has been disconnected: " + error);
                    });

                    if (connection) {
                        // Zaregistrovanie udalosti na zmenu oddu
                        connection.on('OddsChanged', function (oddsID, oddsRate, status) {
                            if (list.Odds.includes(oddsID)) {
                                console.log("--> oddsID: " + oddsID + " <--" + " | oddsRate: " + oddsRate + " | status: " + status);
                                if (+$("#ticketList #" + oddsID + " #crsOriginal")?.text() != oddsRate) {
                                    ticket.ticketDelta();
                                }
                            }
                            if (profile.ConsoleLog || profile.ConsoleLog$.SignalR) console.log(new Date().toISOString()
                                + " | OddsChanged - oddsID: " + oddsID
                                + " | oddsRate: " + oddsRate
                            );
                            events.eventsSignalrModule.oddChanged(oddsID, oddsRate, status);
                        });

                        // Zaregistrovanie udalosti na zmenu oddu - Editacia tiketu
                        connection.on('OddsBuyBackChanged', function (oddsID, oddsRate, buyBackValue, isRemovable) {
                            if (profile.ConsoleLog || profile.ConsoleLog$.SignalR) console.log(new Date().toISOString()
                                + " | OddsBuyBackChanged - oddsID: " + oddsID
                                + " | oddsRate: " + oddsRate
                                + " | buyBackValue: " + buyBackValue
                                + " | isRemovable: " + isRemovable
                            );
                            ticket.ticketEditModule.oddBuyBackChanged(oddsID, oddsRate, buyBackValue, isRemovable);
                        });

                        // Zaregistrovanie udalosti na zmenu oddu
                        connection.on('OddsCreated', function (eventID) {
                            if (profile.ConsoleLog || profile.ConsoleLog$.SignalR) console.log(new Date().toISOString()
                                + " | OddsCreated - oddsID: " + eventID
                            );
                            events.eventsSignalrModule.oddsCreated(eventID);
                        });

                        // Zaregistrovanie udalosti na zmenu oddu
                        connection.on('RefreshView', function (viewToRefresh) {
                            if (profile.ConsoleLog || profile.ConsoleLog$.SignalR) console.log(new Date().toISOString()
                                + " | RefreshView: " + viewToRefresh
                            );
                            if (offer.signalrView.length) {
                                for (var viewIndex = 0; viewIndex < offer.signalrView.length; viewIndex++) {
                                    if (offer.signalrView[viewIndex] === viewToRefresh) {
                                        if (viewToRefresh.substring(0, 2) === 'E_') {
                                            events.eventsSignalrModule.oddsCreated(viewToRefresh.split('E_')[1]);
                                        } else {
                                            if (stream.isStreamPlaying && stream.streamSignalRView === viewToRefresh) {
                                                // View ktore treba refreshnut je pre aktivny stream
                                                if (stream.isActualOfferDifferentAsStream()) {
                                                    // Aktualne sa zobrazuje ina ponuka nez pre udalost ktora ma stream, preto sa na pozadi spravi request na ponuku.
                                                    // Podla toho ci sa zapas nachadza v ponuke vieme ci sa zapas ukoncil
                                                    stream.closeStreamIfFinished();
                                                } else {
                                                    events.eventsSignalrModule.offerListRefresh();
                                                }
                                            } else {
                                                // View ktore treba refreshnut nieje pre aktivny stream
                                                events.eventsSignalrModule.offerListRefresh();
                                            }
                                        }
                                    }
                                }
                            }
                        });

                        // Zaregistrovanie udalosti na zmenu eventChanceType
                        connection.on('EventChanceTypeChanged', function (eventChanceTypeID, status, eventID) {
                                // status = "suspended", "closed", "active"
                                // TODO: na udalosti EventChanceTypeChanged treba zavolat ticketDelta(); idealne v pripade len ak je to nutne
                                // na to aby to bolo mozne optimalne implementovat potrebujeme upravit spravanie oddov pri roznych stavoch (refactor)
                                // -nespoliehat sa na priradene classy oddu na tickete
                                if (offer.signalrView.includes("EVCT_" + eventChanceTypeID)) {
                                    console.log("--> ECT eventChanceTypeID: " + eventChanceTypeID + " | status: " + status + " | eventID: " + eventID);
                                    ticket.ticketDelta();
                                };

                                if (profile.ConsoleLog || profile.ConsoleLog$.SignalR) console.log(new Date().toISOString()
                                    + " | EventChanceTypeChanged - eventChanceTypeID: " + eventChanceTypeID
                                    + " | status: " + status
                                    + " | eventID: " + eventID
                                );
                                events.eventsSignalrModule.offerListChanged(eventChanceTypeID, status, eventID);

                        });

                        // Zaregistrovanie udalosti na zmenu eventu vratane skore
                        connection.on('EventChangedJson', function (data) {
                            if (data && (data = JSON.parse(data))) {
                                if (profile.ConsoleLog || profile.ConsoleLog$.SignalR) console.log(new Date().toISOString()
                                + " | EventChanged - eventID: " + data.EventID
                                + " | actualGamePartID: " + data.ActualGamePartID
                                + " | actualGamePartTime: " + data.ActualGamePartTime
                                + " | score: " + data.Score
                                + " | liveBettingView: " + data.LiveBettingView
                                + " | eventDate: " + data.EventDate
                                );

                                events.eventsSignalrModule.eventChanged(data.EventID, data.ActualGamePartID, data.ActualGamePartTime, data.Score, data.LiveBettingView, data.EventDate);
                                // Pre Evona virtualne hry posielam notstarted / started
                                if (data.LiveBettingView == -1 && offer.leagueCupID && (offer.vgL.evona.includes(offer.leagueCupID))) {
                                    // Zmena stavu/betstop Evona virtualnej hry
                                    console.log('EventChangedJson virtualsEvonaHub eventID: ' + data.EventID + ' actualGamePartID: ' + data.ActualGamePartID + ' actualGamePartTime: ' + data.ActualGamePartTime + ' score: ' + data.Score);
                                    communication.topScreen("virtualsEvonaHub", {eventID: data.EventID, actualGamePartID: data.ActualGamePartID, score: data.Score});
                                }
                            }
                        });
            
                        // SignalR
                        connection.on('StreamAdded', function (raceId, streamUrl, videofileName) {
                            if (profile.ConsoleLog || profile.ConsoleLog$.SignalR) console.log(new Date().toISOString()
                                + " | StreamAdded - raceId: " + raceId
                                + " | streamUrl: " + streamUrl
                            );
                            console.log('StreamAdded virtualsEvonaHub ' + raceId + ' streamUrl: ' + streamUrl);
                            communication.topScreen("virtualsEvonaHub", {raceId: raceId, streamUrl: streamUrl, videofileName: videofileName});
                        });

                        // Zaregistrovanie udalosti na zmenu buyback hodnoty tiketu na zaklade ticketCode
                    connection.on('BuyBackChanged', function (ticketCode, buyBackValue) {
                            if (profile.RedeemTicket) {
                                if (profile.ConsoleLog || profile.ConsoleLog$.SignalR) console.log(new Date().toISOString()
                                    + " | Ticket buyBack changed - ticketCode: " + ticketCode
                                    + " | buyBack value: " + buyBackValue
                                );
                                if (stored.OriginalInputTicket && stored.OriginalInputTicket.PlaceBetTicketCode === ticketCode && !ticketDetail.hasRestriction("redeem")) {
                                    stored.BuyBackValue = buyBackValue;
                                    ticketDetail.ticketRedeemCheck(buyBackValue, stored.AutoBuyBackValue, ((buyBackValue === -1)? true : false));
                                } else if (buyBackValue === -1) {
                                    // Ak su moje tikety aktivne tak ich nanovo stiahne inak vymaze chache
                                    if (ticket.state.getState().actualTab === ticket.state.ticketTabs.MT) {
                                        player.playerTickets.myTicketsFilter(false, true);
                                    } else {
                                        delete cache.MyTickets;
                                    }
                                }
                            }
                        });

                        connection.on('JackpotChanged', function (jackpotCode, jackpotValue) {
                            if (profile.ConsoleLog || profile.ConsoleLog$.SignalR) console.log(new Date().toISOString()
                                + " | JackpotChanged - jackpotCode: " + jackpotCode
                                + " | jackpotValue: " + jackpotValue
                            );
                            events.eventsSignalrModule.jackpotChanged(jackpotCode.toLowerCase(), jackpotValue);
                            console.log('JackpotChanged jackpotCode: ' + jackpotCode + 'jackpotValue: ' + jackpotValue);
                        });
                        
                        // [Betbuilder Aggregator API] MultiOdd SignalR handler
                        connection.on('BbMultiOddChanged', function (subOddsIDs, oddsRate, status) {
                            if (profile.BetBuilderAgg && typeof betbuilderAgg !== "undefined") {
                                betbuilderAgg.signalrModule.handleBbMultiOddChanged(subOddsIDs, oddsRate, status);
                            }
                        });
                        
                        events.eventsSignalrModule.startSignalR();
                    }
            }, 0);
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na spracovanie pridania oddov pri otvorenom detaile zapasu
    oddsCreated: function(eventID) {
        if (offer.eventID && Number(eventID) === offer.eventID) {
            if (!stored.statsAreShown) {
                // Otvoreny event detail v tabe 'Kurzy'
                if (offer.groupActive === "betbuilder") {
                    // Otvoreny tab betbuilder, je treba pri buducom prekliku do ineho tabu znova nacitat detail
                    offer.nextGroupActive = "betbuilder";
                } else {
                    // Otvoreny iny tab ako betbuilder, znova nacita detail
                    offer.nextGroupActive = offer.groupActive;
                    eventDetail.showEventDetail(offer.eventID, null, true);
                    if (profile.FlatCSS) shared.scrollModule.scrollButtons("event");
                }
            } else {
                // Otvoreny event detail v tabe 'Statistiky'
                $("#event #rates").attr('onmousedown', 'eventDetail.eventDetailStats(false); main.refreshBtn(true);');
            }
        }
    },

    // Funkcia na spracovanie udalosti na zmenu oddu
    // Vola sa LEN:
    //  pri signalR udalosti - zmena oddu
    //  pri delte tiketu - zmena oddu
    oddChanged: function(oddID, oddsRate, status) {
        try {
            if (oddID && oddsRate) {
                var e, eRate, arrow = selectedOdds = "";
                e = $("#events fieldset #" + oddID);
                eRate = e.find("#crs");

                if (status && status === "active") {
                    e.removeAttr("odd-status");
                } else {
                    e.attr("odd-status", "locked");
                }

                if (oddsRate > 1) {

                    eRate = eRate.removeClass("no-crs").text();

                    // Porovna deltu s kurzom v ponuke a aktualizuje ho
                    if (oddsRate != eRate) {
                        if (oddsRate < eRate) {
                            arrow = "ArrD";
                        } else if (oddsRate > eRate) {
                            arrow = "ArrU";
                        }

                        // Aktualizuje kurz a prida sipku
                        e.find("#crs").text(oddsRate.toFixed(2));
                        e.find("#flg").closest("a").removeClass("ArrU ArrD").addClass(arrow);
                        selectedOdds = "#events fieldset #" + oddID;
                    }

                    // Ak je otvoreny event detail
                    if (offer.eventID) {
                        var ed, edRate;
                        if (profile.InlineDetailLeagueCups.includes(offer.eventLeagueCupID) && offer.inlineDetail) {
                            ed = $("#events #section #" + oddID);
                        } else {
                            ed = $("#event .chances #" + oddID);
                        }
                        if (ed.length) {
                            edRate = ed.find("#crs").removeClass("no-crs").text();
                            if (status && (status !== ed.attr('odd-status'))) {
                                ed.attr('odd-status', status);
                                switch (status) {
                                    case 'suspended':
                                        ed.attr('odd-visibility', 'locked');
                                        ed.attr('visibility', 'oddToHide');
                                        
                                        // [Betbuilder Aggregator API] Odstránenie suspended oddu z BetBuilder výberu
                                        if (profile.BetBuilderAgg && betbuilderAgg.state.isTabActive) {
                                            betbuilderAgg.handleSuspendedOdds(oddID);
                                        }
                                    break;
                                    case 'active':
                                        ed.attr('odd-visibility', 'showed');
                                        ed.removeAttr('visibility');
                                    break;
                                    default:
                                        ed.attr('odd-visibility', 'hidden');
                                    break;
                                }
        
                                var paramGroup = ed.closest('.chancegroup');
                                if (paramGroup.length) {
                                    // ECT v ktorej sa odd zmenil patri po paramGroup
                                    eventDetail.paramGroupVisible(paramGroup);
                                } else {
                                    // ECT v ktorej sa odd zmenil nepatri do paramGroup
                                    eventDetail.eCTVisible(ed.closest('.chance'));
                                }

                                if (offer.eventLive === "Y") {
                                    // Skryje/zobrazi button prepnutia tabu v detaile zapasu
                                    if (stored.showAnotherTabButtonTimeout) {
                                        clearTimeout(stored.showAnotherTabButtonTimeout);
                                        delete stored.showAnotherTabButtonTimeout;
                                    } else {
                                        stored.showAnotherTabButtonTimeout = setTimeout(function() {
                                            eventDetail.detailShowAnotherTabButton();
                                            clearTimeout(stored.showAnotherTabButtonTimeout);
                                            delete stored.showAnotherTabButtonTimeout;
                                            // Po zmene eventChance type nastavi buttony na scroll
                                            if (profile.FlatCSS) shared.scrollModule.scrollButtons("event");
                                        }, 200);
                                    }
                                }

                            }
                            // Porovna deltu s kurzom v detaile eventu a aktualizuje ho
                            if (oddsRate != edRate) {
                                if (oddsRate < edRate) {
                                    arrow = "ArrD";
                                } else if (oddsRate > eRate) {
                                    arrow = "ArrU";
                                }
        
                                // Aktualizuje kurz a prida sipku
                                ed.find("#crs").text(oddsRate.toFixed(2));
                                ed.find("#flg").closest("a").removeClass("ArrU ArrD").addClass(arrow);
                                if (selectedOdds) selectedOdds += ", ";
                                selectedOdds += "#event .chances #" + oddID;
                            }
                        }
                    }
                    // // Ak najde odd aj na tikete
                    // if (ticket.listCheck(oddID)) {
                    //     var t = $("#ticketList #" + oddID);
                    //     // Update delty kurzov na tikete
                    //     if (!t.hasClass("odd-edited")) {
                    //         var tRate = t.find("#crsOriginal").text();
                    //         // Ak sa nejedna o uz podany odd pri editacii tiketu
                    //         if (oddsRate != tRate) {
                    //             // Porovna deltu s kurzom na tikete a aktualizuje ho
                    //             if (oddsRate < tRate) {
                    //                 arrow = "ArrD";
                    //             } else if (oddsRate > tRate) {
                    //                 arrow = "ArrU";
                    //             }
                    //             // Aktualizuje kurz a prida sipku
                    //             t.find("#crsOriginal").text(oddsRate.toFixed(2)).removeClass().addClass(arrow);
                    //         }
                    //     }
                    // }
                    // // Zhasne sipku po urcitom case
                    if (selectedOdds) events.eventsSignalrModule.hideArrow("O_" + oddID, selectedOdds, "#crsOriginal");
                } else {

                    // Aktualizuje a disabluje kurz
                    eRate.addClass("no-crs").text(oddsRate.toFixed(2));

                    // Ak je otvoreny event detail aktualizuje a disabluje kurz aj tam
                    if (offer.eventID) {
                        $("#event .chances #" + oddID).find("#crs").addClass("no-crs").text(oddsRate.toFixed(2));
                    }

                    // Ak najde odd aj na tikete tak ho odstrani a tym aj odznaci v ponuke
                    if (!ticket.state.getState().isEditTicket && ticket.listCheck(oddID)) ticket.ticketOddModule.ctRemoveOdd(oddID);
                }

                return true;

            } else {
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia, ktora zhasne sipku po urcitom case
    hideArrow: function(oddID, selectedOdds, crsToChange) {
        try {
            if (oddID && selectedOdds) {

                clearTimeout(rfs.Courses[oddID]);
                rfs.Courses[oddID] = setTimeout(function () {

                    $(selectedOdds).find(crsToChange + ", #flg").removeAttr("class").closest("a").removeClass("ArrU ArrD");
                    delete rfs.Courses[oddID];
                }, sets.hideArrow);

                return true;
            } else {
                return false;
            }

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            $(selectedOdds).find(crsToChange + ", #flg").removeAttr("class").closest("a").removeClass("ArrU ArrD");
            delete rfs.Courses[oddID];
            return false;
        }
    },

    // Reload evnetsListu s oneskorenim a obmedzenim max pokusov
    offerListRefresh: function(refreshDelay, attempts, refreshRequestorID) {
        try {
            // Ak sa posiela rovnaky refreshRequestorID tak sa refresh ignoruje
            if (!list.Requestors.includes(refreshRequestorID)) {
                // Udrzuje pole na 8 poslednych refreshRequestorID
                if (refreshRequestorID) {
                    list.Requestors.unshift(refreshRequestorID);
                    list.Requestors = list.Requestors.slice(0, 7);
                }
                // Ak nie je definovane oneskorenie a pocet pokusov tak sa nastavia defualtne hodnoty
                if (!refreshDelay) refreshDelay = 200;
                if (!attempts) attempts = 5;
                // Ak nie je prekroceny pocet pokusov tak resetneRefresh
                if (ct.chanceTypeL < attempts) {
                    ct.chanceTypeL++;
                    clearTimeout(rfs.chanceTypeL);
                    rfs.chanceTypeL = setTimeout(function () {
                        rfs.chanceTypeL = null;
                        ct.chanceTypeL = 1;
                        if (profile.ConsoleLog || profile.ConsoleLog$.LoadPure) console.log(">   OfferListRefresh "
                            + " | refreshRequestorID: " + refreshRequestorID
                            + " | list.Requestors: " + list.Requestors
                        );
                        // Nacitanie zapasov, loadAll parameter nenastavuje offer.top
                        if (offer.pointer) {
                            switch (offer.pointer.substr(0, 1)) {
                                case "F":
                                    if (offer.pointer.replace(/\d/g, '') === "FA") {
                                        // Reload s otvorenymi oblubenymi 1. uroven
                                        service.loadPure("sportsBookRegions", "FA0", true, -1);
                                    } else if (offer.pointer.replace(/\d/g, '') === "FASP") {
                                        // Reload s otvorenymi oblubenymi 2. uroven
                                        service.loadPure("sportsBookLeagues", offer.pointer, true, -1);
                                    }
                                    break;
                                default:
                                    // "L" & "G" & (Otvorene oblubene "L" 3. uroven)
                                    service.loadPure('sportsBookEvents', null, true, -1);
                                    break;
                            }
                        }
                        if (profile.FlatCSS && profile.InlineDetailLeagueCups.includes(offer.eventLeagueCupID) && offer.eventID) {
                            setTimeout(function() {
                                // Otvorenie inline detailu
                                eventDetail.eventDetailInlineModule.showEventDetailInline(offer.eventID, true);
                            });
                        }
                        return true;
                    }, refreshDelay);
                }
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na spracovanie udalosti na zmenu eventChanceType v offerListe, na tikete a v detaile zapasu
    offerListChanged: function(eventChanceTypeID, status, eventID) {
        try {
            var event;
            // Ak prisla zmena pre event ktory je vyrenderovany
            if (eventChanceTypeID && status && eventID && (event = $("#events #M" + eventID)).length) {

                // Ak sa jedna o event, ktory je v liste a ma spravnu master eventChanceType
                if (event.attr("event-chancetype-ID") == eventChanceTypeID) {

                    // Zisti ci ma robit zmenu aj na tikete
                    var oddID;
                    if (oddID = ticket.listCheck(null, eventID)) ;

                    if (status == "active") {
                        // Event v liste ma byt odomknuty
                        event.find("fieldset").removeClass("chanceType-suspended").addClass("chanceType-active");
                        // Odd na tikete ma byt odomknuty
                        if (oddID) $("#ticketList #" + oddID).children().removeClass("ui-disabled");

                    } else if (status == "suspended") {
                        // Event v liste ma byt zamknuty
                        event.find("fieldset").addClass("chanceType-suspended").removeClass("chanceType-active");
                        // Odd na tikete ma byt zamknuty
                        if (oddID) $("#ticketList #" + oddID).children().addClass("ui-disabled");

                    } else {
                        // Event ma byt z listu odstraneny (kvoli headrom sa robi reload)
                        events.eventsSignalrModule.offerListRefresh();
                        // Odd na tikete ma byt zamknuty
                        if (oddID) $("#ticketList #" + oddID).children().addClass("ui-disabled");
                    }

                }
            }
            // Zmena na urovni otvoreneho detailu zapasu
            if (offer.eventID == eventID && (ect = $("#event #ECT" + eventChanceTypeID)) && ect.length && !ect.hasClass('chanceType-' + status)) {

                if (status == "active") {
                    // ChanceType v eventDetaile ma byt odomknuty
                    ect.removeClass("chanceType-suspended chanceType-hidden").addClass("chanceType-active");
            
                } else if (status == "suspended") {
                    // ChanceType v eventDetaile ma byt zamknuty
                    ect.addClass("chanceType-suspended").removeClass("chanceType-active");
                    
                    // [Betbuilder Aggregator API] Odstránenie všetkých oddov z tejto ECT z BetBuilder výberu
                    if (profile.BetBuilderAgg && betbuilderAgg.state.isTabActive) {
                        var suspendedOdds = [];
                        ect.find('a[id]').each(function() {
                            var oddID = $(this).attr('id');
                            if (oddID && oddID.match(/^\d+$/)) {
                                suspendedOdds.push(oddID);
                            }
                        });
                        if (suspendedOdds.length > 0) {
                            betbuilderAgg.handleSuspendedOdds(suspendedOdds);
                        }
                    }
                } else {
                    var grp = ect.closest('.chancegroup');
                    if (grp.length) {
                        // Nad chancetype existuje paramGroup
                        if (!grp.find('.chance').length) {
                            // ParamGroup nema ziadne eventChanceTypes
                            grp.remove();
                        }
                    } else {
                        // ChanceType v eventDetaile ma byt zruseny
                        ect.remove();
                    }
                }
                
                if (offer.eventLive === "Y") {

                    if (stored.showAnotherTabButtonTimeout) {
                        clearTimeout(stored.showAnotherTabButtonTimeout);
                        delete stored.showAnotherTabButtonTimeout;
                    } else {
                        stored.showAnotherTabButtonTimeout = setTimeout(function() {
                            // Skryje/zobrazi button prepnutia tabu v detaile zapasu
                            eventDetail.detailShowAnotherTabButton();
                            clearTimeout(stored.showAnotherTabButtonTimeout);
                            delete stored.showAnotherTabButtonTimeout;
                            // Po zmene eventChance type nastavi buttony na scroll
                            if (profile.FlatCSS) shared.scrollModule.scrollButtons("event");
                        }, 200);
                    }
                }
            }

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na spracovanie na zmenu gamePart, gameTime, score, live
    eventChanged: function(eventID, actualGamePartID, actualGamePartTime, score, liveBettingView, eventDate) {
        try {

            if (offer && eventID) {

                // Pre prematch eventy zmeny nespracuva
                if (!$("#events #M" + eventID).hasClass("prematch-event")) {

                    if (actualGamePartID && actualGamePartTime) {

                        // Aktualizacia gamePartTime & gamePartLabel v events liste
                        var live = eventDetail.parseGamePart(offer.SeSpID, actualGamePartID, actualGamePartTime, eventDate, eventID);
                        $("#events #M" + eventID + " .ui-block-1 .ui-li-desc").html(live.Time + live.Label);

                        // Aktualizacia gamePartTime & gamePartLabel v event detaile ak je otovreny
                        if (offer.eventID == eventID) {
                            $("#eventInfoPart1").html(live.Label);
                            if (live.Time) $("#eventInfoPart2").html(" &nbsp;" + live.Time);
                        }

                        // Aktualizuje gamePartID class v liste
                        if ((live = $("#events #M" + eventID + " .ui-block-1").find(".is-live, .next-live")).length) {
                            if (live.hasClass("next-live"))
                                live.removeClass("next-live").addClass("is-live game-new");
                            live.removeClass(live.attr("class").match(/game-\w+/)[0])
                                .addClass("game-" + actualGamePartID);
                        }

                        // Aktualizuje gamePartID class na evente
                        if ((!profile.FlatCSS && !profile.InlineDetailLeagueCups.includes(offer.eventLeagueCupID) && offer.inlineDetail) && offer.eventID == eventID && (live = $("#event #eventInfo"))) {
                            if (live.hasClass("next-live"))
                                live.removeClass("next-live").addClass("is-live game-new");
                            live.removeClass(live.attr("class").match(/game-\w+/)[0])
                                .addClass("game-" + actualGamePartID);
                        }

                        // Ak sa jedna o virtualne hry
                        if (offer.sportID == offer.vgID) {
                            live = $("#events #M" + eventID + " fieldset");
                            if (!["notstarted", "nonstarted"].includes(actualGamePartID) && !offer.vgL.uofTennis.includes(offer.leagueCupID)) {
                                // Ak sa nejedna o (live) vti 
                                live.addClass("event-suspended");
                                // Ak sa nejedna o (live) vti zavrie detail zapasu
                                if (offer.eventID == eventID && (stored.ExtendedActualOffer && (!offer.vgL.uofTennis.includes(offer.leagueCupID)))) main.closeDialog();
                            }

                            // Zisti poradie bloku detailu zapasu
                            var detailBlock;
                            if (offer.vgL.block5.includes(offer.leagueCupID)) {
                                detailBlock = 5;
                            } else if (stored.ExtendedActualOffer && !([1235, 1236].includes(offer.regionID))) {
                                // Zahrna eventsSexta (okrem viktoriek)
                                if (profile.VirtualsOctava && (offer.regionID === 1239 && offer.provider === offer.providerNameUOF)) {
                                    detailBlock = 12;
                                } else {
                                    detailBlock = 9;
                                }
                            } else {
                                detailBlock = 5;
                            }

                            // Preveri list uvodnych gamePartID pre virtualne hry
                            live = live.find(".ui-block-" + detailBlock + " a");
                            if (["ended"].includes(actualGamePartID)) {
                                live.addClass("ui-disabled").removeClass("virtual-game-play");
                                if (offer.vgL.evona.includes(offer.leagueCupID)) {
                                    // Vynutene refresh offery - poslanie dat na vrchnu obrazovku
                                    service.loadPure('sportsBookEvents', null, true, -1);
                                } else if (offer.vgL.uofRacing.includes(offer.leagueCupID) ||
                                    stored.topScreenVgChannel && stored.topScreenVgChannel.toString() && stored.topScreenVgChannel == channel) {
                                    // Vynutene refresh offery - poslanie dat na vrchnu obrazovku
                                    service.loadPure('sportsBookEvents', null, true, -1);
                                }
                            } else if (offer.vgGameParts.includes(actualGamePartID) || actualGamePartID === "notstarted") {
                                live.removeClass("btn-side-bet").find(".ui-btn-text").empty();
                                if (offer.vgL.uofDogs.includes(offer.leagueCupID)) {
                                    // VG UOF dogs - zapasy idu sekvencne, zo signalR prichadza len actualGamePartID = "notstarted"
                                    if ($("#section li#M" + eventID).hasClass("detail-inline-opened")) {
                                        eventDetail.closeEvent();
                                    }
                                    if (offer.vgL.uofDogs.includes(offer.leagueCupID) && (previosEvent = live.parents(".virtual-event").prevAll()) && previosEvent.length) {
                                        previosEvent.addClass("event-suspended");
                                        previosEvent.find(".ui-block-" + detailBlock + " a").addClass("ui-disabled").removeClass("virtual-game-play");
                                        previosEvent.find(".ui-block-1 p.ui-li-desc").text(stored.GameParts.ended.Name);
                                    }
                                    channel = 0;

                                } else {
                                    channel = live.attr("channel");
                                }

                                if (offer.vgL.evona.includes(offer.leagueCupID) && liveBettingView == -1) {
                                    if (actualGamePartID === "started") {
                                        live.addClass("virtual-game-play virtual-game-playing");
                                    }
                                } else if (offer.vgL.oneVideo.includes(offer.leagueCupID)) {
                                    if (actualGamePartID === "started" && live.parents(".virtual-event").find(".icon-kiron-stream").length) {
                                        live.addClass("virtual-game-play virtual-game-playing");
                                    } else {
                                        live.addClass("virtual-game-play hide-element");
                                    }
                                } else if (offer.vgL.uofRacing.includes(offer.leagueCupID) ||
                                            stored.topScreenVgChannel.toString() && stored.topScreenVgChannel == channel) {
                                    live.addClass("virtual-game-play virtual-game-playing");
                                } else {
                                    live.addClass("virtual-game-play");
                                }
                                // Aktualizuje gamePartID class vo virtual liste
                                if ((live = $("#events #M" + eventID + " .ui-block-1").find(".is-live, .next-live")).length) {
                                    if (live.hasClass("next-live"))
                                        live.removeClass("next-live").addClass("is-live game-started");
                                    live.removeClass(live.attr("class").match(/game-\w+/)[0])
                                        .addClass("game-started");
                                }
                                // Reload eventListu s oneskorenim
                                events.eventsSignalrModule.offerListRefresh(5000, 2, eventID);
                            }
                        }
                    }

                    if (score && score != -1 && !($("#events #M" + eventID).parent().hasClass("events-victoria"))) {

                        // Aktualizacia skore v events liste
                        var scoreBlock = 3; // blok v ktorom je zobrazovane aktualne skore
                        var sportID;
                            if (!(sportID = $("#events #M" + eventID + " .league-title").attr("sport-id"))) {
                                sportID = offer.sportID;
                            } else {
                                sportID = Number(sportID.split("SP")[1]);
                            }
                        if (stored.ExtendedActualOffer) scoreBlock = 2;

                        if (profile.FlatCSS && profile.ExtendedOffer && (offer.parcialScoreSports.includes(sportID) || offer.vgL.uofTennis.includes(offer.leagueCupID))) {
                            var scoreElements = eventDetail.prepareScoreForRender(shared.parseScore(score, sportID));
                            $("#events #M" + eventID + " .ui-block-" + scoreBlock + " .ui-btn-score").empty().append(scoreElements);
                            if (actualGamePartID !== "notstarted") {
                                $("#events #M" + eventID).addClass("full-score");
                            }
                        } else {
                            $("#events #M" + eventID + " .ui-block-" + scoreBlock + " .ui-btn-score").html("<span class='total-result'>" + score.toString().split(" [")[0].split("=")[1].replace(/:/, " : ") + "</span>");
                        }

                        // Aktualizacia skore v event detaile ak je otovreny
                        if (offer.eventID == eventID) {

                            // Sparsuje skore pre eventDetail zobrazenie
                            score = shared.parseScore(score, offer.SeSpID);

                            var titleHomeScore = "<span id='titleHomeScore'>" + shared.resolvePowerPlay(score, sportID, "Home", true) + "<div id='titleHomeLabel'>" + $('#event #titleHomeLabel').text() + "</div></span>";
                            var titleAwayScore = "<span id='titleAwayScore'>" + shared.resolvePowerPlay(score, sportID, "Away", true) + "<div id='titleAwayLabel'>" + $('#event #titleAwayLabel').text() + "</div></span>";
                            $("#event #scoreHeader, #event #scoreParcialH, #event #scoreParcialA").empty();

                            $("#event #scoreHeader").html(eventDetail.eventScoreTable(score, offer.sportID, offer.regionID, "scoreHeader"));
                            $("#event #scoreParcialH").html(titleHomeScore + eventDetail.eventScoreTable(score, offer.sportID, offer.regionID, "scoreHome"));
                            $("#event #scoreParcialA").html(titleAwayScore + eventDetail.eventScoreTable(score, offer.sportID, offer.regionID, "scoreAway"));

                            $("#event #scoreTotalH").text(score.Home.total);
                            $("#event #scoreTotalA").text(score.Away.total);
                        }
                    }

                    // Aktualizuje liveBettingView pre ponuku a eventDetail
                    if (liveBettingView == -1) {
                        $("#events #M" + eventID + " fieldset").addClass("event-suspended");
                        if (offer.eventID == eventID) {
                            if (profile.FlatCSS && profile.InlineDetailLeagueCups.includes(offer.eventLeagueCupID) && offer.inlineDetail) {
                                // Jedna sa o inline detail
                                $("#events .event-detail-inline table").addClass("event-suspended");
                            } else {
                                // Hlaska o nedostupnosti oddov
                                $("#event #liveButtonNotice").text(texts.OfferGroupBetsNonAvailable).show();
                                $("#event .chances").addClass("event-suspended");
                                if (!stream.isStreamPlaying && actualGamePartID == "ended") {
                                    main.closeDialog();
                                }
                            }
                        }
                    } else if (liveBettingView == 1 && offer.sportID != offer.vgID) {
                        $("#events #M" + eventID + " fieldset").removeClass("event-suspended");
                        if (offer.eventID == eventID) {
                            if (profile.FlatCSS && profile.InlineDetailLeagueCups.includes(offer.eventLeagueCupID) && offer.inlineDetail) {
                                // Jedna sa o inline detail
                                $("#events .event-detail-inline table").removeClass("event-suspended chanceType-hidden");
                            } else {
                                $("#event .chances").removeClass("event-suspended chanceType-hidden");

                                // Skryje hlasku o nedostupnosti oddov
                                $("#event #liveButtonNotice").hide();
                            }
                        }
                    }

                } else if (eventDate) {
                    // Zmena datumu len pre prematch
                    var e, event;

                    if ((e = $("#events #M" + eventID)).length) {
                        event = eventDetail.parseEvent(e.attr("liveFeed-reference"), "N", e.children("span").attr("sport-id"), null, null, eventDate);

                        if (event.Date) e.find(".ui-block-1 .ui-btn-text span").text(event.Date);
                        if (event.Time) e.find(".ui-block-1 .ui-li-desc").text(event.Time);

                        if (offer.eventID) {
                            if (event.Date) $("#event #eventInfoPart1").text(event.Date);
                            if (event.Time) $("#event #eventInfoPart1").text(" &nbsp;" + event.Time);
                        }
                    }
                }

                return true;
            } else {
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia sluzi na zmenu hodnoty jackpotu
    jackpotChanged: function(jackpotCode, amount) {
        try {
            if ((cachedJackpot = service.dataCache("Jackpot", "LOAD")) && cachedJackpot.data) {
                // Jackpot sa nachadza v cache
                var data = cachedJackpot.data.map(function(jackpot) {
                    if (jackpotCode === jackpot.JackpotCode.toLowerCase()) {
                        jackpot.JackpotValue = amount;
                    }
                    return jackpot;
                });
                service.dataCache("Jackpot", "SAVE", data);
                events.eventsCompetitionModule.jackpotGet(true);
            } else if ((jackpotElement = $("#tableJackpot #" + jackpotCode).find(".jackpot-value")) && jackpotElement.length) {
                $(jackpotElement).text(shared.floor2(amount, 1) + ' ' + profile.Currency);
            }
            setTimeout(function() {
                communication.topScreen("jackpotChanged", {
                    jackpotCode: jackpotCode,
                    jackpotValue: amount
                });
            }, 500)

            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na zaistenie signalR spojenia
    checkSignalR: function(callback, fallback) {
        try {
            if (connection?.state === signalR.HubConnectionState.Connected) {
                if (profile.ConsoleLog || profile.ConsoleLog$.SignalR) console.log("checkSignalR: Connection is healthy. connection.state: " + connection.state);
                callback();
            } else {
                if (profile.ConsoleLog || profile.ConsoleLog$.SignalR) console.log("checkSignalR: not connected. connection.state: " + connection.state);
                fallback();
            }
        } catch (e) {
            fallback();
            return false;
        }
    }
};
